exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* задаём переменные на корневом элементе компонента */\n.custom-select {\n  --vs-controls-color: #2C3030;\n  --vs-border-color: #DDDDDD;\n  --vs-border-radius: 8px;\n  --vs-font-size: 18px;\n  --vs-line-height: 30px;\n  --vs-dropdown-option--active-bg: #00ccb4;\n  --vs-dropdown-option--active-color: #2C3030;\n}\n\n/* изменения шрифта/веса для выбранного и меню */\n.custom-select .vs__selected,\n.custom-select .vs__dropdown-menu {\n  font-size: 18px !important;\n  font-weight: 600;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ffff624","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/common/UI/SelectWrapper.vue
// module id = EWn4
// module chunks = 1